/**
 * Отправка смс
 * @param data объект, содержащий массив номеров телефонов, cl_service_id, текст сообщения
 */
const sendSms = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/sms/send",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Получение номеров телефонов для отправки смс всем клиентам статистики/детализации/рекламы/опросов
 * @param data объект, содержащий параметры фильтра статистики params,
 * номер севриса cl_service_id,
 * текст сообщения message
 * тип статистики type
 */
const getPhones = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/sms/getPhones",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
export { sendSms, getPhones };
